import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateCapWorksLenderDeactivationReason } from "@/features/LenderHub/shared/store/CapworksLenderDeactivationReason/slices/CapWorksLenderDeactivationReason";

const getCapWorksDeactivationReasons = sharedService.injectEndpoints({
  endpoints: builder => ({
    getCapWorksDeactivationReasons: builder.query({
      query: () => "parameters/capworks-lender-deactivation-reasons",
      transformResponse: response => response.items,
      providesTags: ["CapWorksDeactivationReasons"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateCapWorksLenderDeactivationReason(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetCapWorksDeactivationReasonsQuery } = getCapWorksDeactivationReasons;

